export const TOOLBAR_LABEL = 'Editor Toolbar';
